














































import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Designer from "@/views/Designer.vue";
import Header from "@/components/designer/header/Header.vue";
import { Auth } from "@/mixins/auth";
import { SurchargeStore } from "@/mixins/store";
import { SURCHARGE_MAX_AGE_MS } from "@/store/modules/surcharge/types";
@Component({
  components: {
    Designer,
    Header,
  },
})
export default class App extends mixins(Auth, SurchargeStore) {
  private surchargeTimer: number | null = null;

  /**
   * FUMBSD-761: keep the API's surcharge current while signed in (the endpoint
   * needs a session) -- on load, hourly, and on product line selection
   * (CollectionMenuNew.selectProduct).
   */
  @Watch("isLoggedIn", { immediate: true })
  protected onLoggedInChange(loggedIn: boolean): void {
    this.stopSurchargeTimer();
    if (!loggedIn) return;
    this.refreshSurcharge();
    this.surchargeTimer = window.setInterval(
      () => this.refreshSurcharge(true),
      SURCHARGE_MAX_AGE_MS
    );
  }

  beforeDestroy(): void {
    this.stopSurchargeTimer();
  }

  private stopSurchargeTimer(): void {
    if (this.surchargeTimer !== null) {
      window.clearInterval(this.surchargeTimer);
      this.surchargeTimer = null;
    }
  }

  get staging(): boolean {
    if (process.env.VUE_APP_ENV === "staging") {
      return true;
    } else {
      return false;
    }
  }

  get isTouchDevice(): boolean {
    return (
      window.matchMedia("(pointer: coarse)").matches &&
      window.matchMedia("(hover: none)").matches
    );
  }

  get isPhone(): boolean {
    const { width, height } = this.$vuetify.breakpoint;
    return Math.min(width, height) <= 600;
  }

  get isPortrait(): boolean {
    return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width;
  }

  get isSmallScreen(): boolean {
    if (!this.isTouchDevice) return false;
    return this.isPhone || this.isPortrait;
  }

  @Watch("isSmallScreen", { immediate: true })
  onSmallScreenChange(isSmall: boolean): void {
    if (!isSmall) return;
    this.$nextTick(() => {
      document.querySelectorAll(".vld-overlay").forEach(el => el.remove());
    });
  }

  get showRotatePrompt(): boolean {
    return !this.isPhone && this.isPortrait;
  }
}
